import { Box, Typography, alpha } from "@mui/material";

type SectionHeaderProps = {
  icon: React.ComponentType<{ fontSize?: "small" | "medium" | "large" }>;
  title: string;
  description?: string;
  color?: "primary" | "error";
};

export function SectionHeader({ icon: Icon, title, description, color = "primary" }: SectionHeaderProps) {
  return <Box display="flex" alignItems="flex-start" gap={1.5} mb={2.5}>
    <Box
      sx={{
        display: "grid",
        placeItems: "center",
        width: 36,
        height: 36,
        borderRadius: 2,
        flexShrink: 0,
        color: `${color}.main`,
        bgcolor: (theme) => alpha(theme.palette[color].main, theme.palette.mode === "dark" ? 0.18 : 0.1),
      }}
    >
      <Icon fontSize="small" />
    </Box>
    <Box>
      <Typography variant="h6" fontWeight={700} lineHeight={1.3}>{title}</Typography>
      {description && <Typography variant="body2" color="text.secondary">{description}</Typography>}
    </Box>
  </Box>;
}
